export type IdleCallbackHandle = number | ReturnType<typeof setTimeout>;

type IdleCallbackGlobal = typeof globalThis & {
	requestIdleCallback?: (callback: () => void, options?: { timeout?: number }) => number;
	cancelIdleCallback?: (handle: number) => void;
};

export const scheduleIdleCallback = (callback: () => void, timeoutMs = 1200): IdleCallbackHandle => {
	const idleGlobal = globalThis as IdleCallbackGlobal;
	if (typeof idleGlobal.requestIdleCallback === 'function') {
		return idleGlobal.requestIdleCallback(() => callback(), { timeout: timeoutMs });
	}

	return idleGlobal.setTimeout(callback, timeoutMs);
};

export const cancelIdleCallback = (handle: IdleCallbackHandle) => {
	const idleGlobal = globalThis as IdleCallbackGlobal;
	if (typeof idleGlobal.cancelIdleCallback === 'function' && typeof handle === 'number') {
		idleGlobal.cancelIdleCallback(handle);
		return;
	}

	idleGlobal.clearTimeout(handle as ReturnType<typeof setTimeout>);
};
